/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import howItWorksSectionStyle from "../../../../../components/Sections/Contract/HowItWorksSection/howItWorksSectionStyle";
import Container from "../../../../../components/Container/Container";
import TextContainer from "../../../../../components/Container/TextContainer";
import GradientPaper from "../../../../../components/GradientComponents/GradientPaper";
import UploadIcon from "../../../../../assets/icons/serviceOverview/IconDocumentUpload";
import CallClockIcon from "../../../../../assets/icons/generic/IconCallClock";
import SendMailIcon from "../../../../../assets/icons/generic/IconSendMail";
import { Box } from "@mui/material";
import theme from "../../../../../theme/Theme";
import IconCallOrAiService from "../../../../../assets/icons/serviceOverview/IconCallOrAiService";
import IconWriting from "../../../../../assets/icons/traffic/toggleable/IconWriting";

const HowItWorksSectionAdvocardFlex = () => {
  return (
    <>
      <Container sx={howItWorksSectionStyle.centered}>
        <Box sx={howItWorksSectionStyle.scrollToAnchor} id="so-funktioniert-es" />
        <Typography variant={"h2"}>So einfach funktioniert es</Typography>
      </Container>
      <div>
        <TextContainer sx={howItWorksSectionStyle.centered}>
          <Grid container>
            <Grid item xs={12}>
              <GradientPaper sx={howItWorksSectionStyle.paper}>
                <Grid container sx={howItWorksSectionStyle.advantageContainer}>
                  <Grid item xs={12} sm={4}>
                    <IconWriting sx={howItWorksSectionStyle.icon(theme)} />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Typography variant={"h4"}>Schritt 1</Typography>
                    <Typography>Geben Sie unter “Jetzt starten” Ihre Versicherungsdaten und Ihre Mailadresse ein.</Typography>
                  </Grid>
                </Grid>
                <Grid container sx={howItWorksSectionStyle.advantageContainer}>
                  <Grid item xs={12} sm={8}>
                    <Typography variant={"h4"}>Schritt 2</Typography>
                    <Typography>Stellen Sie Ihre Frage direkt oder buchen Sie eine Erstberatung.</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} sx={howItWorksSectionStyle.gridItemReversed(theme)}>
                    <IconCallOrAiService sx={howItWorksSectionStyle.icon(theme)} />
                  </Grid>
                </Grid>
                <Grid container sx={howItWorksSectionStyle.advantageContainer}>
                  <Grid item xs={12} sm={4}>
                    <UploadIcon sx={howItWorksSectionStyle.icon(theme)} />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Typography variant={"h4"}>Schritt 3</Typography>
                    <Typography>Falls Sie eine Erstberatung gebucht haben: Laden Sie bei Bedarf ihre Dokumente hoch, beispielsweise Ihren Vertrag.</Typography>
                  </Grid>
                </Grid>
                <Grid container sx={howItWorksSectionStyle.advantageContainer}>
                  <Grid item xs={12} sm={8}>
                    <Typography variant={"h4"}>Schritt 4</Typography>
                    <Typography>Vereinbaren Sie einen Termin für eine telefonische anwaltliche Beratung.</Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} sx={howItWorksSectionStyle.gridItemReversed(theme)}>
                    <CallClockIcon sx={howItWorksSectionStyle.icon(theme)} />
                  </Grid>
                </Grid>
                <Grid container sx={howItWorksSectionStyle.advantageContainer}>
                  <Grid item xs={12} sm={4}>
                    <SendMailIcon sx={howItWorksSectionStyle.icon(theme)} />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Typography variant={"h4"}>Schritt 5</Typography>
                    <Typography>Erhalten Sie nach der Erstberatung die wichtigsten Infos per Email.</Typography>
                  </Grid>
                </Grid>
              </GradientPaper>
            </Grid>
          </Grid>
        </TextContainer>
      </div>
    </>
  );
};

export default HowItWorksSectionAdvocardFlex;
